class ImageBlockCarousel extends HTMLElement {
  connectedCallback() {
    this.slides = [...this.querySelectorAll('[data-slide]')];
    this.dots = [...this.querySelectorAll('[data-dot]')];
    if (this.slides.length < 2) return;

    this.speed = parseInt(this.dataset.speed, 10) || 760;
    this.autoplay = this.dataset.autoplay === 'true';
    this.reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    this._show(0);

    this._boundSelect = this._onBlockSelect.bind(this);
    this._boundDeselect = this._onBlockDeselect.bind(this);
    this.addEventListener('shopify:block:select', this._boundSelect);
    this.addEventListener('shopify:block:deselect', this._boundDeselect);

    if (this.autoplay && !this.reduceMotion) this._play();
  }

  disconnectedCallback() {
    clearTimeout(this._timer);
    this.removeEventListener('shopify:block:select', this._boundSelect);
    this.removeEventListener('shopify:block:deselect', this._boundDeselect);
  }

  _show(index) {
    this.slides.forEach((slide, i) => {
      slide.classList.toggle('image-block-carousel__slide--active', i === index);
    });
    this.dots.forEach((dot, i) => {
      dot.classList.toggle('image-block-carousel__dot--active', i === index);
    });
  }

  _play() {
    clearTimeout(this._timer);
    const last = this.slides.length - 1;
    const holds = 3;
    const sequence = [];
    for (let i = 0; i < holds; i++) sequence.push(0);
    for (let i = 1; i <= last; i++) sequence.push(i);
    for (let i = 0; i < holds - 1; i++) sequence.push(last);
    for (let i = last - 1; i >= 1; i--) sequence.push(i);

    let step = 0;
    const tick = () => {
      this._show(sequence[step]);
      step = (step + 1) % sequence.length;
      this._timer = setTimeout(tick, this.speed);
    };
    tick();
  }

  _onBlockSelect(event) {
    clearTimeout(this._timer);
    const index = this.slides.findIndex((slide) => slide === event.target || slide.contains(event.target));
    if (index > -1) this._show(index);
  }

  _onBlockDeselect() {
    if (this.autoplay && !this.reduceMotion) this._play();
  }
}

customElements.define('image-block-carousel', ImageBlockCarousel);
